<template>
  <div class="content if-profile report-tab">
    <div class="md-layout ratios-report">
      <MRReportHeader :headerData="this.headerData" />

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0">
        <!-- <div class="finanical-report-messages">
          <h1 class="md-subheading profile-title">Employment</h1>
          <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>
                How steady is industry employment? Does your firm employ more or
                less than the average in this industry market? This section
                reports on industry and small business employment. If you input
                employment history for your firm, it is benchmarked against the
                averages.
              </p>
            </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>chat_bubble</md-icon>
              </div>
            </md-card-header>
          </div>
        </div>-->
        <div class="md-transparent finanical-report-messages">
          <nav-tabs-card class="p-0 m-0">
            <template slot="content">
              <div class="md-layout">
                <div class="md-layout-item md-size-100  blue-tbl p-0">
                  <md-card class="if_card">
                    <md-card-header>Employment</md-card-header>
                    <md-card-content>
                      <div class="md-layout p-4">
                        <div class="md-layout-item md-size-100">
                          <md-card class="md-card-profile">
                            <md-card-header class="md-card-header-icon">
                              <h4 class="title m-0">
                                <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Industry
                                  Employment</div>
                              </h4>
                              <!-- <h4 class="title text-left">Industry Employment</h4> -->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                  <md-table v-model="tableDataMarketEmployment" table-header-color="blue"
                                    class="profit-and-loss-table">
                                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                                      <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                      <md-table-cell v-for="key in Object.keys(item.dates)" :key="key"
                                        :md-label="years[key]">{{ item.dates[key] }}</md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-medium-size-100 md-size-50">
                          <md-card class="md-card-profile">
                            <md-card-content>
                              <chart-card header-animation="false" :chart-data="colouredLineChart.data"
                                :chart-options="colouredLineChart.options" chart-type="Bar" header-icon
                                chart-inside-content no-footer background-color="blue">
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                      {{ release_display }} Average Industry
                                      Employment
                                    </div>
                                  </h4>
                                  <!-- <h4 class="title">
                                    {{ release_display }} Average Industry Employment
                                  </h4>-->
                                </template>
                              </chart-card>
                              <div class="pie-line" v-if="colouredLineChart && colouredLineChart.data && colouredLineChart.data.series">
                                <ul>
                                  <li v-for="(label, index) in colouredLineChart.data.series" :key="index + '_label'"><span class=""><i :class="'fa fa-square ' + 'chart-label-color-' + index"></i></span> {{ label.name }}</li>
                                </ul>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-medium-size-100 md-size-50">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                  Competitive Market Narrative
                                </div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <div class="extra_space">
                                <!-- <h4 class="Performance Scores">
                                  Competitive Market Narrative
                                </h4> -->
                                <p>
                                  {{ cmnText.employment }}
                                </p>
                              </div>
                            </md-card-content>
                          </md-card>
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                  <md-icon class="color-white">article</md-icon> Employment
                                </div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100">
                                  <div class="extra_space">
                                    <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                    </h4>-->
                                    <p>
                                      How steady is industry employment? Does your firm employ
                                      more or less than the average in this industry market? This
                                      section reports on industry and small business employment.
                                      If you input employment history for your firm, it is benchmarked against the
                                      averages.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>

                      </div>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    MRReportHeader,
  },
  computed: {
    ...mapState({
      employment: (state) => state.user.market_report.data.data['employment'],
      years: (state) => state.user.market_report.data.years,
      release_display: (state) =>
        state.user.market_report.data.general['release_display'],
      cmnText: (state) => state.user.market_report.cmnText,
    }),
  },
  props: ['headerData'],
  data() {
    return {
      view: 'tableDataMarketAnnualSalesy',
      showDialog: false,
      tableDataMarketEmployment: [],
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 80,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
        },
      },
    };
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'tableDataMarketAnnualSales';
    }

    this.switchView(section);
    let me = this;

    this.tableDataMarketEmployment = Object.entries(
      this.employment
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    this.tableDataMarketEmployment.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    let newTableMarketEmployment = Object.entries(
      this.employment
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    newTableMarketEmployment.map((item) => {
      item.dates = item.dates.map((e) => {
        return Number(e);
      });
      return item;
    });
    let newTableMarketEmploymentChart = newTableMarketEmployment;
    newTableMarketEmploymentChart.shift();
    let employmentChartLabels = [];
    employmentChartLabels[0] = this.years[3];
    // let employmentChartData = [];


    this.colouredLineChart.data = {
      labels: employmentChartLabels,
      series: newTableMarketEmploymentChart.map((item) => ({
        name: item.name,
        data: [item.dates[3]],
      })),
    };
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'tableDataMarketAnnualSales';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
  },
};
</script>
<style lang="scss">
</style>
